<template>
  <div class="Child">
    <vxe-table
      height="540"
      border
      ref="xTable1"
      class="radio-table1"
      :data="tableData"
    >
      <vxe-table-column field="orderCode" title="运输单号" min-width="200" />
      <vxe-table-column
        field="mainOrderNumber"
        title="货源单号"
        min-width="220"
      ></vxe-table-column>
      <vxe-table-column
        field="driverName"
        title="实际承运人姓名"
        min-width="100"
      />
      <vxe-table-column
        field="driverPhone"
        title="实际承运人电话"
        min-width="100"
      />
      <vxe-table-column field="vehicleLicense" title="车牌号" min-width="100" />
      <!-- <vxe-table-column field="shipperDeliveryFee" title="托运人打款金额" min-width="150">
        <template v-slot="{row}">{{ (row.shipperDeliveryFee - row.allotTaxAmount).toFixed(2) }}</template>
      </vxe-table-column> -->
    </vxe-table>
  </div>
</template>
<script>
import request from "@/utils/request";
export default {
  name: "orderDetail1",
  data() {
    return {
      loading: false,
      tableData: []
    };
  },
  created() {},
  methods: {
    Getdetails(code) {
      request({
        url: "/ntocc-tms-api/orderDetail/balancePayDeatil",
        method: "get",
        params: { balancePayCode: code }
      }).then(response => {
        this.tableData = response.data;
      });
    }
  }
};
</script>
